const OSS = require('ali-oss')
export default {
  /**
   * 创建随机字符串
   */
  randomString: function (num) {
    let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    let res = ''
    for (let i = 0; i < num; i++) {
      var id = Math.ceil(Math.random() * 35)
      res += chars[id]
    }
    return res
  },
  /**
   * 创建oss客户端对象
   */
  createOssClient (clientData) {
    return new Promise((resolve, reject) => {
      let client = new OSS({
        region: clientData.region,
        accessKeyId: clientData.accessKeyId,
        accessKeySecret: clientData.accessKeySecret,
        bucket: clientData.bucket
      })
      resolve(client)
    })
  },
  /**
   * 标准时间转换字符串
   * @param time
   * @returns {string}
   */
  getTime (time) {
    let date = new Date(time)
    let Y = date.getFullYear()
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    let h = (date.getHours() + 1 < 10 ? '0' + (date.getHours() + 1) : date.getHours() + 1) + ':'
    let m = (date.getMinutes() + 1 < 10 ? '0' + (date.getMinutes() + 1) : date.getMinutes() + 1) + ':'
    let s = (date.getSeconds() + 1 < 10 ? '0' + (date.getSeconds() + 1) : date.getSeconds() + 1)
    return Y + '-' + M + '-' + D + ' ' + h + m + s
  }
}



// WEBPACK FOOTER //
// ./src/util/common.js